import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcInfoTransparent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z",
			fill: "#212329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4669 8.46667C13.4669 9.23987 12.8401 9.86667 12.0669 9.86667C11.2937 9.86667 10.6669 9.23987 10.6669 8.46667C10.6669 7.69347 11.2937 7.06667 12.0669 7.06667C12.8401 7.06667 13.4669 7.69347 13.4669 8.46667Z",
			fill: "#212329"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 10.9999C12.5523 10.9999 13 11.4477 13 11.9999V16.2666C13 16.8189 12.5523 17.2666 12 17.2666C11.4477 17.2666 11 16.8189 11 16.2666V11.9999C11 11.4477 11.4477 10.9999 12 10.9999Z",
			fill: "#212329"
		})
	]
});
export default SvgIcInfoTransparent;
